<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	dayjs.extend(localizedFormat);

	export let race;
	export let meeting;

	function updateRaceAttribute(e, attribute, label, negate = false) {
		let newValue = e.target.checked;
		if (negate) {
			newValue = !e.target.checked;
		}
		RaceStore.updateRaceAttribute(race.id, attribute, newValue)
			.then(() => {
				notify({
					type: 'success',
					title: `R${race.race_number} @ ${meeting.name}`,
					message: `"${label}" updated to "${e.target.checked ? 'ON' : 'OFF'}"`,
					timeout: 3
				});
			})
			.catch(() => {
				notify({
					type: 'danger',
					title: `R${race.race_number} @ ${meeting.name}`,
					message: `Failed to update "${label}"`,
					timeout: 3
				});
			});
	}
</script>

<div class="table-row hover:bg-gray-200">
	<div class="table-cell py-2 border-b border-row-separator">
		{race.race_number}
	</div>
	<div class="table-cell text-left border-b border-row-separator">
		{race.name}
	</div>
	<div class="table-cell border-b border-row-separator">
		{dayjs(race.start_time).format('LT')}
	</div>
	<div class="table-cell border-b border-row-separator">
		<Switch
			on:change={(e) => updateRaceAttribute(e, 'visible', 'Visibility')}
			name={'visibility_' + race.race_number}
			bind:checked={race.visible}
			small={true}
		/>
	</div>
	<div class="table-cell border-b border-row-separator">
		<Switch
			on:change={(e) => updateRaceAttribute(e, 'featured', 'Featured')}
			name={'featured_' + race.race_number}
			bind:checked={race.featured}
			small={true}
		/>
	</div>
	<div class="table-cell border-b border-row-separator">
		<Switch
			on:change={(e) => updateRaceAttribute(e, 'boostable', 'Boost Up')}
			name={'boostable_' + race.race_number}
			checked={race.boostable}
			small={true}
		/>
	</div>
	<div class="table-cell border-b border-row-separator">
		<Switch
			on:change={(e) => updateRaceAttribute(e, 'bonus_disabled', 'Bonus Bets', true)}
			name={'bonus-Disabled_' + race.race_number}
			checked={!race.bonus_disabled}
			small={true}
		/>
	</div>
	<!--<div class="table-cell border-b border-row-separator">
		<Switch
			on:change={(e) => updateRaceAttribute(e, 'cashout_enabled', 'Cash Out')}
			name={'cashout-enabled_' + race.race_number}
			disabled={meeting.cashout_enabled}
			checked={race.cashout_enabled}
			small={true}
		/>
	</div>-->
</div>
